import { render, staticRenderFns } from "./NoticeCate.vue?vue&type=template&id=1905818a&scoped=true"
import script from "./NoticeCate.vue?vue&type=script&lang=js"
export * from "./NoticeCate.vue?vue&type=script&lang=js"
import style0 from "./NoticeCate.vue?vue&type=style&index=0&id=1905818a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1905818a",
  null
  
)

export default component.exports